<template>
  <b-button-group variant="outline">
    <b-button
      variant="dark"
      class="btn-pill btn-sm"
      @click="updateJaar(value - 5)"
    >
      --
    </b-button>
    <b-button
      variant="dark"
      class="btn-pill btn-sm"
      @click="updateJaar(value-1)"
    >
      -
    </b-button>
    <b-button
      variant="dark"
      class="btn-pill btn-sm"
      @click="updateJaar(null)"
    >
      {{ value }}
    </b-button>
    <b-button
      variant="dark"
      class="btn-pill btn-sm"
      @click="updateJaar(value+1)"
    >
      +
    </b-button>
    <b-button
      variant="dark"
      class="btn-pill btn-sm"
      @click="updateJaar(value + 5)"
    >
      ++
    </b-button>
  </b-button-group>
</template>
<script>
export default {
    name: 'JaarInput',
    props: {
        value: {
            type: Number
        }
    },
    methods: {
        updateJaar(jaar) {
            this.$emit('input',jaar);
        }
    }
}
</script>